module.exports = __webpack_public_path__ + "static/media/171IT211.7279457a.jpeg";